import { mount } from 'svelte';
import App from '../auth/App.svelte';

const target = document.getElementById('auth-root');
if (target) {
  window.auth = mount(App, { target });
}
